import React from 'react'
import "./Experience.css"

function Experience() {
  return (
    <div className="experience">
    <div className="achievement">
<div className="circle">8+</div>
<span>Years</span>
<span>Experience</span>
</div>
<div className="achievement">
<div className='circle' >20+</div>
<span>Completed</span>
<span>Project</span>
</div>
<div className="achievement">
<div className='circle'>20+</div>
<span>Compaines</span>
<span>work</span>
</div>
    
    </div>
  )
}

export default Experience
